import React, { useEffect, useState } from 'react';
import { BrandsService, BrandPublicResponse, configureApiClient } from '../../api/client';
import BrandPortal from './BrandPortal';

export default function BrandEntry({ children }: { children: React.ReactNode }) {
  const [brand, setBrand] = useState<BrandPublicResponse | null>(null);
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let active = true;
    configureApiClient();
    BrandsService.getApiBrandsResolve(window.location.hostname).then(b => { if (active) setBrand(b); }).catch(e => { if (active && e.status !== 404) setFailed(true); }).finally(() => { if (active) setLoaded(true); });
    return () => { active = false; };
  }, []);
  if (!loaded) return <p role="status" className="container py-5">載入品牌中…</p>;
  if (failed) return <div className="container py-5" role="alert">品牌資料載入失敗。<button onClick={() => window.location.reload()}>重試</button></div>;
  if (['/privacy-policy', '/driver-app'].includes(window.location.pathname)) return <>{children}</>;
  if (!brand) return (
    <main className="container py-5" role="alert">
      <h1>此網站尚未開放預約</h1>
      <p>目前網址尚未設定預約品牌，請聯絡客服取得正確的品牌預約網址。</p>
    </main>
  );
  return <BrandPortal brand={brand} />;
}
